import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'html-widget',
  templateUrl: './html-widget.component.html',
  styleUrls: ['./html-widget.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HtmlWidgetComponent {
  
  value: string;
  showInWidget = false;

  @Input() id: number;
  @Input() set settings(val: any){
    this.value = val.value;
    this.showInWidget = val.showInWidget;
  }

  // added to suppress error message in F12 console
  @Input() subjectId;
  @Input() processTypeId;
  
  constructor() {}
}
